<template>
  <div class="page form col-2" style="max-width: 100%; ">
    <div class="header-tools-bar">
      <h2>订单详情</h2>
    </div>

    <el-row :gutter="27">
      <el-col :span="12">
        <el-alert class="alert-loud" v-if="form.remarks"
                  :title="form.remarks"
                  type="warning"/>

        <el-form class="form" ref="form" :model="form" label-width="120px" size="small">
          <el-form-item label="订单编号">
            <span>{{ form.id }}</span>
            <el-tag class="mrl-10">{{ form.type }}</el-tag>
          </el-form-item>
          <el-form-item label="下单用户">
            <router-link :to="'/user-info??id=' + form.user.id" v-text="form.user.realname || form.user.nickname"/>
            <el-tag class="mrl-10">UID: {{ form.user.id }}</el-tag>
          </el-form-item>
          <el-form-item label="订单状态">
            {{ form.status }}
            <span v-if="form.status === '申请退款中'">
              <el-button-group>
                <el-button type="primary" @click="() => showRefundDialog = true">同意</el-button>
                <el-button type="info" @click="() => onHandleRefund(false)">拒绝</el-button>
              </el-button-group>
            </span>
            <!--<el-tag v-if="form.status === '已取消'" type="danger">{{ form.status }}</el-tag>-->
            <!--<el-tag v-else>{{ form.status }}</el-tag>-->
          </el-form-item>
          <el-form-item label="商品原价">
            <el-input class="input-short-2" :value="form.fee_original"/>
          </el-form-item>
          <el-form-item label="折扣金额">
            <el-input class="input-short-2 " :value="form.fee_discount">
              <!--<el-button slot="append">查看所用优惠券</el-button>-->
            </el-input>
          </el-form-item>
          <el-form-item label="支付金额">
            <el-input class="input-short-2" :value="form.fee_paid">
              <el-button slot="prepend">微信支付</el-button>
            </el-input>
          </el-form-item>

          <el-form-item label="商户订单号" v-if="form.out_trade_no">
            {{ form.out_trade_no }}
          </el-form-item>
          <el-form-item label="微信支付单号" v-if="form.wx_prepay_id">
            {{ form.wx_prepay_id }}
          </el-form-item>
          <el-form-item label="微信交易单号" v-if="form.wx_transaction_id">
            {{ form.wx_transaction_id }}
          </el-form-item>
          <el-form-item label="订单说明">
            <el-input type="textarea" :value="form.tip">
            </el-input>
          </el-form-item>

          <el-form-item label="收货人">
            <el-input class="input-short-2" v-model="form.recv_name"/>
          </el-form-item>
          <el-form-item label="收获地址">
            <el-input v-model="form.recv_address"/>
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input v-model="form.recv_tel"/>
          </el-form-item>
          <el-form-item label="快递类型">
            <el-select v-model="form.express_type" placeholder="选择类型">
              <el-option v-for="t in $dbus.config.express_options" :key="t" :label="t" :value="t"/>
            </el-select>
          </el-form-item>
          <el-form-item label="单号">
            <el-input v-model="form.express_num" clearable></el-input>
          </el-form-item>
          <el-form-item label="快递费用">
            <el-input class="input-short-2 " :value="form.amount_express" />
          </el-form-item>
          <el-form-item label="时间">
            <ul>
              <li>订单创建：{{ form.datetime_created }}</li>
              <li>订单支付：{{ form.datetime_paid }}</li>
              <li>订单发货：{{ form.datetime_sent }}</li>
              <li>订单完成：{{ form.datetime_done }}</li>
            </ul>
          </el-form-item>

          <el-form-item label="顾客留言">
            <el-input v-model="form.remarks" type="textarea" autosize/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">更新</el-button>
            <el-button-group style="margin-left: 20px">
              <el-button @click="load">刷新</el-button>
              <el-button @click="()=> showRefundDialog = true">退款</el-button>
              <el-button @click="onComplete" v-if="form.status !== '已取消'">完成订单</el-button>
              <el-button @click="onCancel" v-if="form.status !== '已取消'">取消订单</el-button>
              <el-button type="success" @click="showSendDialog = true">发货</el-button>
            </el-button-group>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-card class="order-ticket">
          <el-form size="mini">
            <el-form-item label="订单ID">{{ form.id }}</el-form-item>
            <el-form-item label="收货人">{{ form.recv_name }}</el-form-item>
            <el-form-item label="联系方式">{{ form.recv_tel }}</el-form-item>
            <el-form-item label="地址">{{ form.recv_address }}</el-form-item>
            <hr>
            <div style="margin: 20px 15px; font-size: 13px">
              <div v-for="g in form.goods" :key="g.id"
                   style="display: flex; justify-content: space-between; align-items: center">
                <div>
                  <div style="font-size: 16px;">
                    <router-link :to="'/shop/goods-editor?id=' + g.id" v-text="g.title"/>
                  </div>
                  <div style="color: #888; font-size: 14px">所选规格：{{ g.spec_path || '默认' }}</div>
                </div>
                <div>￥{{g.price}} x {{ g.num }}</div>
              </div>
            </div>
            <hr>
            <el-form-item label="快递方式">{{ form.express_type }}</el-form-item>
            <el-form-item label="快递单号">{{ form.express_num }}</el-form-item>
            <hr>
            <el-form-item label="商品总额">{{ form.fee_original }}</el-form-item>
            <el-form-item label="优惠"> - {{ form.fee_discount }}</el-form-item>
            <el-form-item label="运费">{{ form.fee_express }}</el-form-item>
            <el-form-item label="实际支付">{{ form.fee_paid }}</el-form-item>
            <hr>
            <el-form-item label="订单创建时间">{{ form.datetime_created }}</el-form-item>
            <el-form-item label="支付时间">{{ form.datetime_paid }}</el-form-item>
            <el-form-item label="发货时间">{{ form.datetime_send }}</el-form-item>
            <el-form-item label="完成时间">{{ form.datetime_done }}</el-form-item>
          </el-form>
        </el-card>

      </el-col>
    </el-row>

    <section>
      <h3>订单物流
        <el-button class="mrl-10" type="mini" @click="loadExpressRecords">刷新</el-button>
      </h3>
      <ul class="express-track" v-if="express_track.length !== 0">
        <li v-for="row in express_track">{{ row }}</li>
      </ul>
      <ul class="express-track" v-else>
        暂无物流信息
      </ul>
    </section>

    <section>
      <h3>订单操作记录</h3>
      <el-table stripe :data="records">
        <el-table-column prop="title" label="操作"/>
        <el-table-column prop="user.nickname" label="用户" width="130"/>
        <el-table-column prop="datetime_created" label="时间" width="160"/>
      </el-table>
    </section>


    <el-dialog
      title="填写快递单号"
      :visible.sync="showSendDialog"
      width="400px">
      <el-form class="_form" label-width="70px">
        <el-form-item label="快递类型">
          <el-select v-model="form.express_type" placeholder="选择快递">
            <el-option v-for="item in $dbus.config.express_options"
                       :key="item" :label="item" :value="item"/>
          </el-select>
        </el-form-item>
        <el-form-item label="单号">
          <el-input v-model="form.express_num" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSendDialog = false">取消</el-button>
        <el-button type="primary" @click="onSendGoods">发货</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="loadingRefund?'正在请求微信处理退款':'退款'"
      :visible.sync="showRefundDialog"
      width="400px">
      <el-form class="_form" label-width="70px">
        <el-form-item label="退款金额">
          <el-input-number v-model="refund_amount" clearable></el-input-number>
          <el-button type="text" @click="() => refund_amount = form.fee_paid ">全部退款</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRefundDialog = false">取 消</el-button>
        <el-button type="primary" @click="onHandleRefund" :loading="loadingRefund">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loadingRefund: false,
        showSendDialog: false,
        showRefundDialog: false,
        refund_amount: 0,
        express_track: [],
        records: [],
        form: {
          id: this.$route.query.id,
          user: {},
          recv_name: '',
          recv_address: '',
          recv_tel: '',
          goods: [],
          status: '',
          datetime_created: '',
          datetime_paid: '',
          datetime_sent: null,
          datetime_done: null,
          remarks: '',
        }
      }
    },
    mounted() {
      this.load()
    },
    methods: {
      load() {
        this.$api.request('/order/get', {id: this.$route.query.id}).then(data => {
          this.form = data
          this.loadExpressRecords()
        })
      },
      loadExpressRecords() {
        if (this.form.express_num && this.form.express_type) {
          this.$api.request('/query_express_info', {
            com: this.form.express_type,
            num: this.form.express_num
          }).then(data => {
            if (data.error) {
              return this.$message.error(data.error)
            }
            this.express_track = data.records
          })
        }
      },
      onSubmit() {
        this.showSendDialog = false
        this.$api.request('/order/update', {id: this.$route.query.id, form: this.form}).then(data => {
          this.form = data
          this.$message.success('订单修改成功!')
        })
      },
      onSendGoods() {
        this.$api.request('/order/do_send_express', {
          id: this.$route.query.id,
          express_type: this.form.express_type,
          express_num: this.form.express_num
        }).then(data => {
          this.form = data
          this.$message.success('订单发货成功!')
          this.showSendDialog = false
        })
      },
      onCancel() {
        this.$api.request('/order/update', {id: this.$route.query.id, form: {status: '已取消'}})
          .then(data => {
            this.form = data
            this.$message.success('订单已取消!')
            document.body.scrollTop = document.documentElement.scrollTop = 0
          })
      },
      onComplete() {
        this.$api.request('/order/update', {id: this.$route.query.id, form: {status: '已完成'}})
          .then(data => {
            this.form = data
          })
      },
      onClickQ() {
        this.$message.success('已通知用户')
      },
      onClickSend() {
        this.showSendDialog = true
        this.$message.success('订单发货成功')
      },
      onHandleRefund(t) {
        if (t) {
          this.$confirm('是否同意该用户的退款申请？').then(() => {
            this.loadingRefund = true
            if (!this.refund_amount) {
              return this.$message.error('金额不能为 0')
            }
            this.$api.request('/order/refund_payment', {
              id: this.$route.query.id,
              status: true,
              amount: this.refund_amount
            }).then(data => {
              this.loadingRefund = true
              this.showRefundDialog = false
              if (data.error) {
                return this.$message.error(data.error)
              }
              this.$message.success('操作成功')
              this.load()
            })
          })
        } else {
          this.$prompt('请填写拒绝理由').then(({value}) => {
            this.$api.request('/order/update',
              {id: this.$route.query.id, form: {tip: value, status: '待发货'}}).then(data => {
              this.$message.success('操作成功')
              this.load()
            })
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .express-track {
    padding: 7px 40px;

    li {
      margin: 13px 0;
      font-size: 13px;
      color: #666;

      &:first-child {
        color: red;
      }
    }

  }
</style>

